import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import styled from 'styled-components';
import Header from './Header';
import GDPRCookieBanner from './GDPRCookieBanner';
import { CookiesProvider } from 'react-cookie';
import SEO from './SEO';
import theme from '../styles/mui-theme';
import Footer from './Footer';

const LayoutContainer = styled.div`
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  padding: 1em;
`;

interface LayoutProps {
  children: React.ReactElement | React.ReactElement[];
  customSEO?: boolean;
}

const Layout = ({ children, customSEO }: LayoutProps) => (
  <CookiesProvider>
    {!customSEO && <SEO />}
    <ThemeProvider theme={theme}>
      <LayoutContainer>
        <CssBaseline />
        <Header />
        {children}
      </LayoutContainer>
      <Footer />
      <GDPRCookieBanner />
    </ThemeProvider>
  </CookiesProvider>
);

export default Layout;
